import * as TinyEmitter from 'tiny-emitter';

declare global {
    // eslint-disable-next-line no-var
    var AUTH_EVENT_BUS: TinyEmitter.TinyEmitter | undefined;
}

const emitter = globalThis.AUTH_EVENT_BUS ?? new TinyEmitter.TinyEmitter();
globalThis.AUTH_EVENT_BUS = emitter;

export { emitter };
